import type { ComponentType } from 'react'
import { useEffect, useState } from 'react'

export const LazyToaster = () => {
  const [Toaster, setToaster] = useState<ComponentType | null>(null)

  useEffect(() => {
    const loadToaster = () => {
      void import('react-hot-toast').then(({ Toaster: HotToaster }) => {
        setToaster(() => HotToaster)
      })
    }

    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadToaster)
    } else {
      setTimeout(loadToaster, 0)
    }
  }, [])

  return Toaster ? <Toaster /> : null
}
